import { UserType } from '../interfaces/userType.enum';

/**
 * The roles StocktakeController admits on every endpoint (create, counts, approve, cancel, get,
 * list-by-institution): @PreAuthorize("hasAnyRole('StoreAdmin', 'StoreManager', 'InstitutionAdmin')").
 * One list feeds the route guard, the sidebar and the modules page so they cannot drift apart.
 */
export const STOCKTAKE_ROLES: UserType[] = [UserType.InstitutionAdmin, UserType.StoreAdmin, UserType.StoreManager];
